import React, { useState, useEffect } from "react";
import {
  TextField,
  Button,
  Grid,
  Container,
  Snackbar,
  Paper,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  FormHelperText,
  Autocomplete,
} from "@mui/material";
import MuiAlert from "@mui/material/Alert";
import apiService from "../components/ReasuableFuncations/api";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const StakeholderManagement = () => {
  const [name, setname] = useState("");
  const [stakeholderType, setStakeholderType] = useState("");
  const [typeOptions, setTypeOptions] = useState([
    "Member State",
    "Public Sector",
    "Public - Private Partnership",
    "Development Partner",
  ]);
  const [role, setRole] = useState("");
  const [regionalNetworkOption, setRegionalNetworkOption] = useState("");
  const [countryOption, setCountryOption] = useState("");
  const [contactInfo, setContactInfo] = useState({
    phone: {
      countryCode: "+27",
      number: "",
    },
    email: "",
    address: "",
  });
  const [projects, setProjects] = useState([]);
  const [selectedProject, setSelectedProject] = useState("");
  const [stakeholderId, setStakeholderId] = useState("");
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [errors, setErrors] = useState({});

  const [isOtpSent, setIsOtpSent] = useState(false);
  const [otp, setOtp] = useState("");
  const [isPhoneVerified, setIsPhoneVerified] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [isSavingStakeholder, setIsSavingStakeholder] = useState(false);
  const [isAssigningStakeholder, setIsAssigningStakeholder] = useState(false);

  const regionStates = {
    COMESA: [
      "Burundi",
      "Comoros",
      "Democratic Republic of the Congo (DRC)",
      "Djibouti",
      "Egypt",
      "Eritrea",
      "Burundi",
      "Eswatini",
      "Ethiopia",
      "Kenya",
      "Libya",
      "Madagascar",
      "Malawi",
      "Mauritius",
      "Rwanda",
      "Seychelles",
      "Somalia",
      "South Sudan",
      "Sudan",
      "Zambia",
      "Zimbabwe",
      "Tanzania",
    ],
    EAC: ["Burundi", "Kenya", "Rwanda", "South Sudan", "Tanzania", "Uganda","Congo","Somalia"],
    IGAD: [
      "Djibouti",
      "Eritrea",
      "Ethiopia",
      "Kenya",
      "Somalia",
      "South Sudan",
      "Sudan",
      "Uganda",
    ],
    IOC: [
      "Comoros",
      "France (Réunion)",
      "Madagascar",
      "Mauritius",
      "Seychelles",
    ],
    SADC: [
      "Angola",
      "Botswana",
      "Comoros",
      "Democratic Republic of the Congo (DRC)",
      "Eswatini",
      "Lesotho",
      "Madagascar",
      "Malawi",
      "Mozambique",
      "Namibia",
      "Seychelles",
      "South Africa",
      "Tanzania",
      "Zambia",
      "Zimbabwe",
      "Tanzania",
    ],
  };

  const countryCodes = [
    { code: "+1", country: "United States" },
    { code: "+1", country: "Canada" },
    { code: "+44", country: "United Kingdom" },
    { code: "+61", country: "Australia" },
    { code: "+49", country: "Germany" },
    { code: "+33", country: "France" },
    { code: "+39", country: "Italy" },
    { code: "+81", country: "Japan" },
    { code: "+86", country: "China" },
    { code: "+91", country: "India" },
    { code: "+34", country: "Spain" },
    { code: "+41", country: "Switzerland" },
    { code: "+46", country: "Sweden" },
    { code: "+31", country: "Netherlands" },
    { code: "+55", country: "Brazil" },
    { code: "+61", country: "New Zealand" },
    { code: "+65", country: "Singapore" },
    { code: "+66", country: "Thailand" },
    { code: "+7", country: "Russia" },
    { code: "+60", country: "Malaysia" },
    { code: "+52", country: "Mexico" },
    { code: "+63", country: "Philippines" },
    { code: "+27", country: "South Africa" },

    // Additional African countries
    { code: "+213", country: "Algeria" },
    { code: "+244", country: "Angola" },
    { code: "+229", country: "Benin" },
    { code: "+267", country: "Botswana" },
    { code: "+226", country: "Burkina Faso" },
    { code: "+257", country: "Burundi" },
    { code: "+237", country: "Cameroon" },
    { code: "+238", country: "Cape Verde" },
    { code: "+236", country: "Central African Republic" },
    { code: "+235", country: "Chad" },
    { code: "+269", country: "Comoros" },
    { code: "+243", country: "Democratic Republic of the Congo" },
    { code: "+242", country: "Republic of the Congo" },
    { code: "+225", country: "Côte d'Ivoire" },
    { code: "+253", country: "Djibouti" },
    { code: "+20", country: "Egypt" },
    { code: "+240", country: "Equatorial Guinea" },
    { code: "+291", country: "Eritrea" },
    { code: "+251", country: "Ethiopia" },
    { code: "+241", country: "Gabon" },
    { code: "+220", country: "Gambia" },
    { code: "+233", country: "Ghana" },
    { code: "+224", country: "Guinea" },
    { code: "+245", country: "Guinea-Bissau" },
    { code: "+254", country: "Kenya" },
    { code: "+266", country: "Lesotho" },
    { code: "+231", country: "Liberia" },
    { code: "+218", country: "Libya" },
    { code: "+261", country: "Madagascar" },
    { code: "+265", country: "Malawi" },
    { code: "+223", country: "Mali" },
    { code: "+222", country: "Mauritania" },
    { code: "+230", country: "Mauritius" },
    { code: "+212", country: "Morocco" },
    { code: "+258", country: "Mozambique" },
    { code: "+264", country: "Namibia" },
    { code: "+227", country: "Niger" },
    { code: "+234", country: "Nigeria" },
    { code: "+250", country: "Rwanda" },
    { code: "+290", country: "Saint Helena" },
    { code: "+248", country: "Seychelles" },
    { code: "+232", country: "Sierra Leone" },
    { code: "+252", country: "Somalia" },
    { code: "+211", country: "South Sudan" },
    { code: "+249", country: "Sudan" },
    { code: "+268", country: "Eswatini" },
    { code: "+255", country: "Tanzania" },
    { code: "+228", country: "Togo" },
    { code: "+216", country: "Tunisia" },
    { code: "+256", country: "Uganda" },
    { code: "+260", country: "Zambia" },
    { code: "+263", country: "Zimbabwe" },
  ];

  useEffect(() => {
    fetchProjects();
  }, []);
  useEffect(() => {
    // Scroll to the top of the page when the component mounts
    window.scrollTo(0, 0);
  }, []);

  const fetchProjects = async () => {
    const userData = JSON.parse(localStorage.getItem("user"));
    if (!userData) {
      console.error("User data not found. Redirecting to login.");
      return;
    }
    const {
      selectedOption,
      regionalNetworkOption,
      memberStateOption,
      countryOption,
    } = userData;
    let url = `/api/projects-stake`;

    try {
      let response;
      if (selectedOption === "Comesa") {
        response = await apiService.get(`/api/project-data`);
      } else if (
        selectedOption === "Regional Network" &&
        regionalNetworkOption
      ) {
        response = await apiService.get(
          `${url}?regionalNetwork=${regionalNetworkOption}`
        );
      } else if (selectedOption === "Member State" && memberStateOption) {
        response = await apiService.get(`${url}?country=${countryOption}`);
      }

      if (response && response.statusText !== "OK") {
        throw new Error("Failed to fetch projects");
      }

      const data = response.data;
      setProjects(data);
    } catch (error) {
      console.error("Error fetching projects:", error);
    }
  };

  const handleTypeChange = (event, newValue) => {
    if (!newValue) {
      setStakeholderType("");
      return;
    }
    if (!typeOptions.includes(newValue)) {
      setTypeOptions([...typeOptions, newValue]);
    }
    setStakeholderType(newValue);
  };

  const handleSendOTP = async () => {
    const fullPhoneNumber = `${contactInfo.phone.countryCode}${contactInfo.phone.number}`;
    if (!contactInfo.phone.number) {
      setSnackbarMessage("Please enter a phone number");
      setSnackbarSeverity("error");
      setOpenSnackbar(true);
      return;
    }

    setIsSubmitting(true);
    try {
      const response = await apiService.post(`/api/send-otp`, {
        phoneNumber: fullPhoneNumber,
      });

      if (response.statusText !== "OK") {
        throw new Error("Failed to send OTP");
      }

      setIsOtpSent(true);
      setSnackbarMessage("OTP sent successfully!");
      setSnackbarSeverity("success");
      setOpenSnackbar(true);
    } catch (error) {
      setSnackbarMessage("Failed to send OTP. Please try again.");
      setSnackbarSeverity("error");
      setOpenSnackbar(true);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleVerifyOTP = async () => {
    if (!otp) {
      setSnackbarMessage("Please enter OTP");
      setSnackbarSeverity("error");
      setOpenSnackbar(true);
      return;
    }

    setIsSubmitting(true);
    try {
      const response = await apiService.post(`/api/verify-otp`, {
        phoneNumber: `${contactInfo.phone.countryCode}${contactInfo.phone.number}`,
        otp: otp,
      });

      if (response.statusText !== "OK") {
        throw new Error("Invalid OTP");
      }

      setIsPhoneVerified(true);
      setSnackbarMessage("Phone number verified successfully!");
      setSnackbarSeverity("success");
      setOpenSnackbar(true);
    } catch (error) {
      setSnackbarMessage("Invalid OTP. Please try again.");
      setSnackbarSeverity("error");
      setOpenSnackbar(true);
    } finally {
      setIsSubmitting(false);
    }
  };

  const generateUsername = (name) => {
    // Generate username from name + random number
    const cleanName = name.toLowerCase().replace(/[^a-z0-9]/g, '');
    const randomNum = Math.floor(Math.random() * 1000);
    return `${cleanName}${randomNum}`;
  };

  const generatePassword = () => {
    const length = 12;
    const charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*";
    let password = "";
    for (let i = 0; i < length; i++) {
      password += charset.charAt(Math.floor(Math.random() * charset.length));
    }
    return password;
  };

  const handleSaveStakeholder = async (e) => {
    e.preventDefault();
    setIsSavingStakeholder(true);

    try {
      const stakeholderData = {
        name,
        type: stakeholderType,
        role,
        contactInfo: {
          ...contactInfo,
          phone: `${contactInfo.phone.countryCode}${contactInfo.phone.number}`,
          isVerified: isPhoneVerified,
        },
        selectedOption: "Member State",
        regionalNetworkOption, // This is from the Region dropdown
        memberStateOption: regionalNetworkOption, // Use the same value
        countryOption,
      };

      const response = await apiService.post(`/api/stakeholders`, stakeholderData);

      if (response.data && response.data.message) {
        if (response.status === 409) {
          setSnackbarMessage(response.data.message);
          setSnackbarSeverity("error");
          setOpenSnackbar(true);
          return;
        }
      }

      const savedStakeholder = response.data;
      setStakeholderId(savedStakeholder._id);
      setSnackbarMessage("Stakeholder added successfully! Login credentials have been sent via email.");
      setSnackbarSeverity("success");
      setOpenSnackbar(true);

      // Reset form fields
      // setname("");
      // setStakeholderType("");
      // setRole("");
      // setContactInfo({
      //   phone: { countryCode: "+254", number: "" },
      //   email: "",
      //   address: "",
      // });
    } catch (error) {
      if (error.response) {
        setSnackbarMessage(error.response.data.message || "Error adding stakeholder. Please try again.");
      } else {
        setSnackbarMessage("Error adding stakeholder. Please try again.");
      }
      setSnackbarSeverity("error");
      setOpenSnackbar(true);
    } finally {
      setIsSavingStakeholder(false);
    }
  };

  const handleAssignStakeholder = async () => {
    if (!selectedProject) {
      setSnackbarMessage("Please select a project to assign the stakeholder.");
      setSnackbarSeverity("error");
      setOpenSnackbar(true);
      return;
    }

    setIsAssigningStakeholder(true);

    try {
      if (!stakeholderId) {
        throw new Error("Stakeholder not available for assignment");
      }

      const assignResponse = await apiService.put(
        `/api/stakeholders/${stakeholderId}/assign`,
        { 
          projectId: selectedProject,
          name: name,
          username: generateUsername(name),
          password: generatePassword()
        }
      );

      if (!assignResponse.statusText) {
        const errorData = assignResponse.data;
        throw new Error(
          errorData.message || "Failed to assign stakeholder to project"
        );
      }

      setSnackbarMessage(
        "Stakeholder assigned and notification email sent successfully!"
      );
      setSnackbarSeverity("success");
      setOpenSnackbar(true);

      // Reset form
      setname("");
      setStakeholderType("");
      setRole("");
      setContactInfo({
        phone: { countryCode: "+254", number: "" },
        email: "",
        address: "",
      });
      setSelectedProject("");
      setStakeholderId("");
      setIsPhoneVerified(false);
      setIsOtpSent(false);
      setOtp("");
    } catch (error) {
      console.error("Error:", error);
      setSnackbarMessage(
        error.message || "Error in stakeholder assignment process"
      );
      setSnackbarSeverity("error");
      setOpenSnackbar(true);
    } finally {
      setIsAssigningStakeholder(false);
    }
  };

  return (
    <Container maxWidth="md" sx={{ paddingRight: "40px" }}>
      <Paper elevation={20} sx={{ p: 4, mt: 4 }}>
        <form onSubmit={handleSaveStakeholder}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                label="Stakeholder Name"
                fullWidth
                required
                value={name}
                onChange={(e) => setname(e.target.value)}
                error={!!errors.name}
                helperText={errors.name}
              />
            </Grid>
            <Grid item xs={12}>
              <FormControl fullWidth error={!!errors.stakeholderType}>
                <Autocomplete
                  value={stakeholderType}
                  onChange={handleTypeChange}
                  options={typeOptions}
                  freeSolo
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Stakeholder Type"
                      variant="outlined"
                      error={!!errors.stakeholderType}
                      required
                    />
                  )}
                />

                {errors.stakeholderType && (
                  <FormHelperText>{errors.stakeholderType}</FormHelperText>
                )}
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <InputLabel>Region</InputLabel>
                <Select
                  onChange={(e) => setRegionalNetworkOption(e.target.value)}
                  label="Region"
                >
                  <MenuItem value="COMESA">COMESA</MenuItem>
                  <MenuItem value="EAC">EAC</MenuItem>
                  <MenuItem value="IGAD">IGAD</MenuItem>
                  <MenuItem value="IOC">IOC</MenuItem>
                  <MenuItem value="SADC">SADC</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <InputLabel>Country State</InputLabel>
                <Select
                  value={countryOption}
                  onChange={(e) => setCountryOption(e.target.value)}
                  label="Member State"
                >
                  {regionalNetworkOption &&
                    regionStates[regionalNetworkOption].map((state) => (
                      <MenuItem key={state} value={state}>
                        {state}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Roles"
                fullWidth
                required
                value={role}
                onChange={(e) => setRole(e.target.value)}
                error={!!errors.role}
                helperText={errors.role}
              />
            </Grid>

            {/* <Grid container spacing={2}> */}
            {/* Country Code Select */}
            <Grid item xs={12} sm={4}>
              <FormControl fullWidth>
                <InputLabel>Country Code</InputLabel>
                <Select
                  value={contactInfo.phone.countryCode}
                  onChange={(e) =>
                    setContactInfo({
                      ...contactInfo,
                      phone: {
                        ...contactInfo.phone,
                        countryCode: e.target.value,
                      },
                    })
                  }
                  label="Country Code"
                  disabled={isPhoneVerified}
                >
                  {countryCodes.map((country) => (
                    <MenuItem key={country.code} value={country.code}>
                      {`${country.code} (${country.country})`}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            {/* Phone Number Input */}
            <Grid item xs={12} sm={8}>
              <TextField
                label="Phone Number"
                type="number"
                fullWidth
                required
                value={contactInfo.phone.number}
                onChange={(e) =>
                  setContactInfo({
                    ...contactInfo,
                    phone: {
                      ...contactInfo.phone,
                      number: e.target.value,
                    },
                  })
                }
                disabled={isPhoneVerified}
                placeholder="Enter phone number"
              />
            </Grid>

            {/* Send OTP Button */}
            {/* <Grid item xs={12} sm={3}>
              <Button
                variant="contained"
                color={isOtpSent ? "warning" : "primary"}
                onClick={handleSendOTP}
                disabled={isSubmitting || isPhoneVerified}
                fullWidth
                sx={{ height: "56px" }}
              >
                {isSubmitting
                  ? "Sending..."
                  : isOtpSent
                  ? "Resend OTP"
                  : "Send OTP"}
              </Button>
            </Grid> */}

            {/* OTP Section */}
            {isOtpSent && !isPhoneVerified && (
              <>
                <Grid item xs={12} sm={9}>
                  <TextField
                    label="Enter OTP"
                    fullWidth
                    value={otp}
                    onChange={(e) => setOtp(e.target.value)}
                    placeholder="Enter 6-digit OTP"
                  />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <Button
                    variant="contained"
                    color="success"
                    onClick={handleVerifyOTP}
                    disabled={isSubmitting}
                    fullWidth
                    sx={{ height: "56px" }}
                  >
                    {isSubmitting ? "Verifying..." : "Verify OTP"}
                  </Button>
                </Grid>
              </>
            )}
            {/* </Grid> */}

            <Grid item xs={12}>
              <TextField
                label="Email"
                fullWidth
                required
                value={contactInfo.email}
                onChange={(e) =>
                  setContactInfo({ ...contactInfo, email: e.target.value })
                }
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Address"
                fullWidth
                required
                value={contactInfo.address}
                onChange={(e) =>
                  setContactInfo({ ...contactInfo, address: e.target.value })
                }
              />
            </Grid>
            <Grid item xs={12}>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                fullWidth
                disabled={isSavingStakeholder}
              >
                {isSavingStakeholder ? "Saving..." : "Save Stakeholder"}
              </Button>
            </Grid>
            <Grid item xs={12}>
              <FormControl fullWidth>
                <InputLabel>Select Project</InputLabel>
                <Select
                  value={selectedProject}
                  onChange={(e) => setSelectedProject(e.target.value)}
                  label="Select Project"
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  {projects.map((project) => (
                    <MenuItem key={project._id} value={project._id}>
                      {project.projectName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <Button
                variant="contained"
                color="success"
                onClick={handleAssignStakeholder}
                fullWidth
                disabled={isAssigningStakeholder || !stakeholderId}
              >
                {isAssigningStakeholder
                  ? "Assigning..."
                  : "Assign Stakeholder to Project"}
              </Button>
            </Grid>
          </Grid>
        </form>
        <Snackbar
          open={openSnackbar}
          autoHideDuration={6000}
          onClose={() => setOpenSnackbar(false)}
        >
          <Alert
            onClose={() => setOpenSnackbar(false)}
            severity={snackbarSeverity}
            sx={{ width: "100%" }}
          >
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </Paper>
    </Container>
  );
};

export default StakeholderManagement;
